import { motion } from 'framer-motion';
import { FaLinkedin } from 'react-icons/fa';
import { SiGooglescholar } from 'react-icons/si';

export default function Contact() {
    return (
        <section id="contact" className="bg-gray-50 dark:bg-[#152033] py-8 border-t border-gray-200 dark:border-gray-800 w-full">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                >
                    <h2 className="text-2xl font-display font-bold text-center text-gray-900 dark:text-white mb-12">Contact Me</h2>
                </motion.div>

                <div className="grid md:grid-cols-2 gap-8">

                    <motion.div
                        className="bg-white dark:bg-surface-dark p-8 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700"
                        initial={{ opacity: 0, x: -30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6, delay: 0.2 }}
                    >
                        <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-6">Get in Touch</h3>
                        <div className="space-y-6">

                            <div className="flex items-center group">
                                <div className="w-10 h-10 bg-blue-50 dark:bg-blue-900/30 rounded-full flex items-center justify-center mr-4 group-hover:bg-blue-100 dark:group-hover:bg-blue-900/50 transition-colors">
                                    <span className="material-icons text-primary dark:text-blue-400 text-sm">email</span>
                                </div>
                                <div>
                                    <p className="text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wider font-semibold">Primary Email</p>
                                    <a href="mailto:priyankakatiyar65@gmail.com" className="text-gray-900 dark:text-white font-medium hover:text-primary dark:hover:text-blue-400 transition-colors">
                                        priyankakatiyar65@gmail.com
                                    </a>
                                </div>
                            </div>

                            <div className="flex items-center group">
                                <div className="w-10 h-10 bg-blue-50 dark:bg-blue-900/30 rounded-full flex items-center justify-center mr-4 group-hover:bg-blue-100 dark:group-hover:bg-blue-900/50 transition-colors">
                                    <span className="material-icons text-primary dark:text-blue-400 text-sm">email</span>
                                </div>
                                <div>
                                    <p className="text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wider font-semibold">Academic Email</p>
                                    <a href="mailto:priyanka@snu.edu.in" className="text-gray-900 dark:text-white font-medium hover:text-primary dark:hover:text-blue-400 transition-colors">
                                        priyanka@snu.edu.in
                                    </a>
                                </div>
                            </div>

                            <div className="flex items-center group">
                                <div className="w-10 h-10 bg-green-50 dark:bg-green-900/30 rounded-full flex items-center justify-center mr-4 group-hover:bg-green-100 dark:group-hover:bg-green-900/50 transition-colors">
                                    <span className="material-icons text-green-600 dark:text-green-400 text-sm">phone</span>
                                </div>
                                <div>
                                    <p className="text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wider font-semibold">Phone</p>
                                    <p className="text-gray-900 dark:text-white font-medium">
                                        <a href="tel:+919354390743" className="hover:text-primary dark:hover:text-blue-400 transition-colors">
                                            9354390743
                                        </a>
                                        <span className="text-gray-500 dark:text-gray-400">, Extn: 338</span>
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-center group">
                                <div className="w-10 h-10 bg-purple-50 dark:bg-purple-900/30 rounded-full flex items-center justify-center mr-4 group-hover:bg-purple-100 dark:group-hover:bg-purple-900/50 transition-colors">
                                    <span className="material-icons text-purple-600 dark:text-purple-400 text-sm">location_on</span>
                                </div>
                                <div>
                                    <p className="text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wider font-semibold">Office</p>
                                    <p className="text-gray-900 dark:text-white font-medium">
                                        Shiv Nadar University<br />
                                        Greater Noida, UP, India
                                    </p>
                                </div>
                            </div>

                        </div>
                    </motion.div>

                    <motion.div
                        className="bg-white dark:bg-surface-dark p-8 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700"
                        initial={{ opacity: 0, x: 30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6, delay: 0.4 }}
                    >
                        <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-6">Academic Profiles</h3>
                        <div className="space-y-6">

                            <a href="https://scholar.google.com/citations?hl=en&authuser=1&user=lLEBAwQAAAAJ" target="_blank" rel="noopener noreferrer" className="flex items-center group p-3 -m-3 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors">
                                <div className="w-12 h-12 bg-blue-100 dark:bg-blue-900/40 rounded-full flex items-center justify-center mr-4 group-hover:scale-110 transition-transform">
                                    <SiGooglescholar className="text-blue-600 dark:text-blue-400 text-xl" />
                                </div>
                                <div>
                                    <h4 className="font-bold text-gray-900 dark:text-white group-hover:text-primary dark:group-hover:text-blue-400 transition-colors">Google Scholar</h4>
                                    <p className="text-sm text-gray-500 dark:text-gray-400">Citations & Publications</p>
                                </div>
                                <span className="material-icons ml-auto text-gray-400 group-hover:text-primary dark:group-hover:text-blue-400">chevron_right</span>
                            </a>

                            <a href="https://www.linkedin.com/in/priyanka-k-3930a852/" target="_blank" rel="noopener noreferrer" className="flex items-center group p-3 -m-3 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors">
                                <div className="w-12 h-12 bg-blue-100 dark:bg-blue-900/40 rounded-full flex items-center justify-center mr-4 group-hover:scale-110 transition-transform">
                                    <FaLinkedin className="text-blue-600 dark:text-blue-400 text-xl" />
                                </div>
                                <div>
                                    <h4 className="font-bold text-gray-900 dark:text-white group-hover:text-primary dark:group-hover:text-blue-400 transition-colors">LinkedIn</h4>
                                    <p className="text-sm text-gray-500 dark:text-gray-400">Professional Network</p>
                                </div>
                                <span className="material-icons ml-auto text-gray-400 group-hover:text-primary dark:group-hover:text-blue-400">chevron_right</span>
                            </a>

                            <a href="https://www.scopus.com/authid/detail.uri?authorId=57195930083" target="_blank" rel="noopener noreferrer" className="flex items-center group p-3 -m-3 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors">
                                <div className="w-12 h-12 bg-orange-100 dark:bg-orange-900/40 rounded-full flex items-center justify-center mr-4 group-hover:scale-110 transition-transform">
                                    <span className="text-orange-600 dark:text-orange-400 font-bold text-xl">S</span>
                                </div>
                                <div>
                                    <h4 className="font-bold text-gray-900 dark:text-white group-hover:text-orange-600 dark:group-hover:text-orange-400 transition-colors">Scopus</h4>
                                    <p className="text-sm text-gray-500 dark:text-gray-400">Research Index</p>
                                </div>
                                <span className="material-icons ml-auto text-gray-400 group-hover:text-orange-600 dark:group-hover:text-orange-400">chevron_right</span>
                            </a>

                            <a href="https://www.researchgate.net/profile/Priyanka-Priyanka-3" target="_blank" rel="noopener noreferrer" className="flex items-center group p-3 -m-3 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors">
                                <div className="w-12 h-12 bg-teal-100 dark:bg-teal-900/40 rounded-full flex items-center justify-center mr-4 group-hover:scale-110 transition-transform">
                                    <span className="text-teal-600 dark:text-teal-400 font-bold text-xl">R</span>
                                </div>
                                <div>
                                    <h4 className="font-bold text-gray-900 dark:text-white group-hover:text-teal-600 dark:group-hover:text-teal-400 transition-colors">ResearchGate</h4>
                                    <p className="text-sm text-gray-500 dark:text-gray-400">Academic Network</p>
                                </div>
                                <span className="material-icons ml-auto text-gray-400 group-hover:text-teal-600 dark:group-hover:text-teal-400">chevron_right</span>
                            </a>

                        </div>
                    </motion.div>

                </div>
            </div>
        </section>
    );
}
